export const insertBizNode = () => () => {
    return async function (nodes, type) {
        await this.execute(
            () => this.actions.insertBizNode(nodes, type)
        )
    }
}
